// extracted by mini-css-extract-plugin
module.exports = {"cardOrder":"_2YUoy","cardLastOrderItem":"_7JVL8","status":"_3L1Yf","date":"_2_iX5","productNumber":"_2ig2i","price":"_1NLiK"};